import type {TStore} from "modules/types/store";

export const getErrorsStore = (store: TStore) => store.error;
export const getGameErrorMessage = (store: TStore) => store.error.gameError;
